import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const useAccounts = (activeProject, user) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAccounts = useCallback(async () => {
    if (!activeProject?._id) return;
    setLoading(true);
    try {
      const res = await axios.get(`/api/projects/${activeProject._id}/accounts`);
      setAccounts(res.data);
    } catch (err) {
      console.error('Error fetching accounts:', err);
    } finally {
      setLoading(false);
    }
  }, [activeProject?._id]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  const addAccount = async (formData) => {
    try {
      await axios.post(`/api/projects/${activeProject._id}/accounts`, formData);
      fetchAccounts();
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error adding account');
      return false;
    }
  };

  const updateAccount = async (id, formData) => {
    try {
      await axios.put(`/api/projects/${activeProject._id}/accounts/${id}`, formData);
      fetchAccounts();
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error updating account');
      return false;
    }
  };

  const projectMember = activeProject?.members?.find(m => m.user === user?._id);
  const isEditor = user?.type === 'admin' || projectMember?.role === 'editor';

  return {
    accounts,
    loading,
    isEditor,
    fetchAccounts,
    addAccount,
    updateAccount
  };
};
